import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y, Autoplay, Grid } from 'swiper/modules';

import Container from '@common/Container';
import Section from '@common/Section';
import Img from '@common/Image';

const Gallery = ({ data }) => {
  const {
    title,
    showTitle,
    images
  } = data;
  return (
    <Section spacing='my-5'>
      <Container>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4 col-lg-10 text-center'>{title}</Heading>}
        {images &&
          <Swiper
            className='overflow-visible'
            modules={[A11y, Autoplay, Grid]}
            spaceBetween={20}
            slidesPerView={1}
            slidesPerGroup={1}
            centeredSlides={false}
            loop={true}
            autoplay={{
              delay: 1, // Nearly instant delay to mimic continuous movement
              disableOnInteraction: false, // Resume autoplay after interaction
            }}
            speed={3000} // Control scrolling speed (adjust as needed)
            breakpoints={{
              960: {
                slidesPerView: 3,
                slidesPerGroup: 1
              }
            }}
          >
            {images.map((image, index) => (
              <SwiperSlide key={index}>
                <Img image={image.gatsbyImageData} file={image.file}  className='rounded' />
              </SwiperSlide>
            ))}
          </Swiper>
        }
      </Container>
    </Section>
  )
}

export default Gallery
